<template>
  <div
    id="header"
    class="header-menu p-0 container-fluid header-min-height bg-white"
    fixed="top"
    :class="{ 'shadow-sm rounded': scroll }"
  >
    <template>
      <b-navbar class="p-0 justify-content-between header-height">
        <menu-logos />

        <div class="d-flex align-items-center">
          <menu-links :isMobile="isMobile" @logout="attemptLogout" />
          <b-icon-list v-b-toggle.sidebar-menu v-if="isMobile" font-scale="2.3" class="mr-3" />
        </div>
      </b-navbar>
    </template>

    <menu-sidebar v-if="isMobile">
      <menu-links />
    </menu-sidebar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MenuLogos from "../../molecules/MenuLogos";
import MenuLinks from "../../molecules/MenuLinks";
import MenuSidebar from "./MenuSidebar";

export default {
  name: "MenuContainer",
  components: {
    MenuLogos,
    MenuLinks,
    MenuSidebar,
  },
  data() {
    return {
      companyLogo: "",
      scroll: false,
      isMobile: window.innerWidth <= 1024,
      homeRoute: "",
    };
  },
  created() {
    window.addEventListener("resize", () => {
      this.isMobile = innerWidth <= 1024;
    });
    window.addEventListener("scroll", this.isScrolling);
  },
  methods: {
    ...mapActions("user", ["logout", "getMenu"]),
    isScrolling(event) {
      this.scroll = true;

      if (window.scrollY === 0) {
        this.scroll = false;
      }
    },
    async attemptLogout() {
      await this.logout();
      window.location.replace(process.env.VUE_APP_ACCOUNTS_URL);
    },
  },
  destroyed() {
    window.removeEventListener("resize", () => {});
    window.removeEventListener("scroll", () => {});
  },
};
</script>

<style scoped lang="scss">
.header-menu {
  position: fixed !important;
  top: 0px !important;
  transition: all 0.15s linear;
  z-index: 99;
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
</style>
